import type { RootState } from '..';

export const selectCumulativeScore = (state: RootState) =>
  state.levelResults.cumulativeScore;
export const selectLevelResults = (state: RootState) =>
  state.levelResults.levelResults;
export const selectLastGameResult = (state: RootState) =>
  state.levelResults.lastGameResult;

// Level end selectors
export const selectLevelEndState = (state: RootState) =>
  state.game.levelEndState;
export const selectShouldEndLevel = (state: RootState) =>
  state.game.levelEndState.shouldEndLevel;
export const selectLevelEndReason = (state: RootState) =>
  state.game.levelEndState.endReason;
export const selectLevelEndTimeRemaining = (state: RootState) =>
  state.game.levelEndState.timeRemaining;
export const selectLevelClearedByEvidence = (state: RootState) =>
  state.game.levelEndState.clearedByEvidence;
